import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import NewUserPage from "PFModules/admin/users/new/new_user_page";
import React from "react";

import { useNewUSerPage } from "./use_new_user_page";

const initPage = { permissionsGroups: null, loaded: false };

const NewUSerController = () => {
  const { loaded, permissionsGroups, errors } = useNewUSerPage(initPage);
  const WrappedNewUser = usePageWrapper(NewUserPage);

  return (
    <WrappedNewUser
      loading={!loaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message={"It looks like the Custom Fields page could not be loaded."}
          buttonMessage={"Please try to come back later"}
          buttonUrl="/admin/custom_fields"
        />
      }
      permissionsGroups={permissionsGroups}
    />
  );
};

export default NewUSerController;
